import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../../features/api/apiSlice";
import Error from "../ui/Error";
import Loader from "../ui/Loader";
import Book from "./Book";

export default function Books() {
  //Vaiables
  const { data: books, isLoading, isError } = useGetBooksQuery();
  const { featured, searchText } = useSelector((state) => state.filter);

  //Functions
  const filterByFeature = (book) => {
    switch (featured) {
      case "featured":
        return book.featured;
      default:
        return true;
    }
  };

  const filterBySearchText = (book) => {
    if (searchText?.length > 0) {
      return (book?.name).toLowerCase().includes(searchText.toLowerCase());
    }
    return true;
  };

  // decide what to render
  let content = null;

  if (isLoading) {
    content = (<>
      <Loader />
      <Loader />
      <Loader />
    </>);
  }

  if (!isLoading && isError) {
    content = <Error message="There was an error" />;
  }

  if (!isLoading && !isError && books?.length === 0) {
    content = <div>No Books Found!</div>
  }

  if (!isLoading && !isError && books?.length > 0) {
    content = books.filter(filterByFeature).filter(filterBySearchText).map((book) => <Book key={book.id} book={book} />);
  }

  return (
    <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {content}
    </div>
  )
}
